/* tslint:disable */
/* eslint-disable */
/**
 * Tenants API
 * API for managing tenants
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncomeDto } from './IncomeDto';
import {
    IncomeDtoFromJSON,
    IncomeDtoFromJSONTyped,
    IncomeDtoToJSON,
    IncomeDtoToJSONTyped,
} from './IncomeDto';
import type { GuarantorDto } from './GuarantorDto';
import {
    GuarantorDtoFromJSON,
    GuarantorDtoFromJSONTyped,
    GuarantorDtoToJSON,
    GuarantorDtoToJSONTyped,
} from './GuarantorDto';

/**
 * 
 * @export
 * @interface UpsertTenantCommand
 */
export interface UpsertTenantCommand {
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    realEstateId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    firstName: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    birthDate: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    civilityId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    employmentStatusId?: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    checkInDate: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    checkOutDate?: string;
    /**
     * Déclaration « à jour de ses loyers » — exigée pour un locataire en place (≥ 6 mois au début du contrat). Null = ne pas modifier la déclaration existante.
     * 
     * @type {boolean}
     * @memberof UpsertTenantCommand
     */
    rentPaymentsUpToDate?: boolean | null;
    /**
     * 
     * @type {Array<IncomeDto>}
     * @memberof UpsertTenantCommand
     */
    incomes: Array<IncomeDto>;
    /**
     * 
     * @type {GuarantorDto}
     * @memberof UpsertTenantCommand
     */
    guarantor?: GuarantorDto;
    /**
     * 
     * @type {string}
     * @memberof UpsertTenantCommand
     */
    riskId?: string;
}

/**
 * Check if a given object implements the UpsertTenantCommand interface.
 */
export function instanceOfUpsertTenantCommand(value: object): value is UpsertTenantCommand {
    if (!('realEstateId' in value) || value['realEstateId'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('checkInDate' in value) || value['checkInDate'] === undefined) return false;
    if (!('incomes' in value) || value['incomes'] === undefined) return false;
    return true;
}

export function UpsertTenantCommandFromJSON(json: any): UpsertTenantCommand {
    return UpsertTenantCommandFromJSONTyped(json, false);
}

export function UpsertTenantCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertTenantCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'realEstateId': json['realEstateId'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'birthDate': json['birthDate'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'civilityId': json['civilityId'],
        'employmentStatusId': json['employmentStatusId'] == null ? undefined : json['employmentStatusId'],
        'checkInDate': json['checkInDate'],
        'checkOutDate': json['checkOutDate'] == null ? undefined : json['checkOutDate'],
        'rentPaymentsUpToDate': json['rentPaymentsUpToDate'] == null ? undefined : json['rentPaymentsUpToDate'],
        'incomes': ((json['incomes'] as Array<any>).map(IncomeDtoFromJSON)),
        'guarantor': json['guarantor'] == null ? undefined : GuarantorDtoFromJSON(json['guarantor']),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
    };
}

export function UpsertTenantCommandToJSON(json: any): UpsertTenantCommand {
    return UpsertTenantCommandToJSONTyped(json, false);
}

export function UpsertTenantCommandToJSONTyped(value?: UpsertTenantCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'realEstateId': value['realEstateId'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'birthDate': value['birthDate'],
        'phone': value['phone'],
        'email': value['email'],
        'civilityId': value['civilityId'],
        'employmentStatusId': value['employmentStatusId'],
        'checkInDate': value['checkInDate'],
        'checkOutDate': value['checkOutDate'],
        'rentPaymentsUpToDate': value['rentPaymentsUpToDate'],
        'incomes': ((value['incomes'] as Array<any>).map(IncomeDtoToJSON)),
        'guarantor': GuarantorDtoToJSON(value['guarantor']),
        'riskId': value['riskId'],
    };
}

